<template>
  <div class="p-room-form">
    <transition name="v-fade">
      <Alert v-if="error" size="sm">{{ error }}</Alert>
    </transition>
    <div v-if="isEditing" class="p-room-form__editing">
      <div class="p-room-form__editing-head">
        <div class="p-room-form__editing-title">
          <img
            src="/assets/icons/Pencil.svg"
            alt=""
            class="p-room-form__editing-icon"
          />
          <span>メッセージを編集中</span>
        </div>
        <button class="p-room-form__editing-close" @click="cancelEdit">
          <img src="/assets/icons/Cross.svg" alt="" />
        </button>
      </div>
    </div>
    <div class="p-room-form__action">
      <FormFiles />
      <div class="p-room-form__submit">
        <Button
          variant="primary"
          :class="{ 'is-loading': isProcessing }"
          :disabled="!message.trim()"
          @click="submit"
        >
          送信
        </Button>
      </div>
    </div>
    <Textarea
      v-model="message"
      autosize
      :rows="1"
      ref="textarea"
      :class="textareaClass"
      @focus.native="onFocus"
    />
  </div>
</template>

<script>
import { ERROR_MESSAGE, ERROR_MESSAGE_SHOW_DURATION } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import FormFiles from '@/components/room/FormFiles';
import Textarea from '@/components/Textarea';
import utils from '@/utils';

export default {
  components: {
    Alert,
    Button,
    FormFiles,
    Textarea
  },
  data() {
    return {
      error: '',
      editingMessageId: '',
      message: '',
      timeoutId: null,
      isProcessing: false
    };
  },
  computed: {
    isEditing() {
      return !!this.editingMessageId;
    },
    isCompany() {
      return utils.isCompany(this.$store.state.role.name);
    },
    textareaClass() {
      return {
        'is-editing': this.isEditing,
        'p-room-form__textarea': true
      };
    },
    room() {
      return this.$store.getters.currentRoom;
    },
    isReadOnlyMode() {
      return this.$store.state.isReadOnlyMode;
    }
  },
  mounted() {
    this.focusTextarea();
    this.$root.$on('room-form-edit-start', this.startEdit);
    this.$root.$on('room-form-edit-clear', this.handleEditClear);
  },
  beforeDestroy() {
    this.$root.$off('room-form-edit-start', this.startEdit);
    this.$root.$off('room-form-edit-clear', this.handleEditClear);
  },
  methods: {
    focusTextarea() {
      if (!this.$refs.textarea) {
        return;
      }
      const textarea =
        this.$refs.textarea.$refs.textarea || this.$refs.textarea.$el;
      textarea.focus();
      const valueLength = textarea.value.length;
      textarea.setSelectionRange(valueLength, valueLength);
    },
    startEdit(payload) {
      this.editingMessageId = payload.id;
      this.message = payload.message;
      this.$nextTick(() => {
        this.focusTextarea();
      });
    },
    handleEditClear(messageId) {
      if (this.editingMessageId === messageId) {
        this.cancelEdit();
      }
    },
    cancelEdit() {
      this.editingMessageId = '';
      this.message = '';
    },
    onFocus() {
      if (this.isReadOnlyMode) {
        return;
      }
      if (
        !this.room ||
        !this.isCompany ||
        !this.room.companyManualUnreadMessageId ||
        !this.room.id
      ) {
        return;
      }
      this.$store.dispatch('setRoom', {
        companyManualUnreadDatetime: null,
        companyManualUnreadMessageId: null,
        id: this.room.id
      });
      this.$firebase
        .updateRoomData(this.room.id, {
          company_manual_unread_datetime: null,
          company_manual_unread_message_id: null
        })
        .catch(() => {});
    },
    reset() {
      this.editingMessageId = '';
      this.message = '';
    },
    showError(error) {
      clearTimeout(this.timeoutId);
      this.error = error;
      // 一定時間経過でエラーメッセージを非表示にする
      this.timeoutId = setTimeout(() => {
        this.error = '';
      }, ERROR_MESSAGE_SHOW_DURATION);
    },
    submit() {
      if (this.isReadOnlyMode) {
        return;
      }
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      const message = this.message.trim();
      const editingMessageId = this.editingMessageId;
      const saveMessage = this.message;
      // 送信完了するまで待つのが微妙にストレスなので、先にリセットする
      this.reset();
      this.focusTextarea();

      const params = {
        message: message
      };

      const request = editingMessageId
        ? this.$firebase.updateMessageData(this.room.id, editingMessageId, {
            isEdited: true,
            message: message
          })
        : this.$firebase.addMessage(this.room.id, params, this.room);
      request
        .then(() => {
          this.isProcessing = false;
        })
        .catch(() => {
          // 送信に失敗したらメッセージを復元する
          this.editingMessageId = editingMessageId;
          this.message = saveMessage;
          this.isProcessing = false;
          this.showError(ERROR_MESSAGE.send);
        });
    }
  }
};
</script>
